import { useEffect } from "react";

/**
 * Cursor + touch starfield.
 * Spawns short-lived DOM sparkles that fade out via CSS.
 * Works on desktop (pointermove) AND touch devices (touchmove / touchstart).
 * Each sparkle auto-removes after its 1200ms animation.
 */
export default function StarfieldCursor() {
  useEffect(() => {
    if (typeof window === "undefined") return;
    let last = 0;
    const THROTTLE = 40;

    const spawn = (x, y) => {
      const now = Date.now();
      if (now - last < THROTTLE) return;
      last = now;
      const star = document.createElement("span");
      star.className = "yuo-star";
      const jitter = () => (Math.random() - 0.5) * 18;
      star.style.left = `${x + jitter()}px`;
      star.style.top = `${y + jitter()}px`;
      document.body.appendChild(star);
      window.setTimeout(() => star.remove(), 1300);
    };

    const onPointer = (e) => spawn(e.clientX, e.clientY);
    const onTouch = (e) => {
      const t = e.touches && e.touches[0];
      if (t) spawn(t.clientX, t.clientY);
    };

    window.addEventListener("pointermove", onPointer, { passive: true });
    window.addEventListener("touchmove", onTouch, { passive: true });
    window.addEventListener("touchstart", onTouch, { passive: true });
    return () => {
      window.removeEventListener("pointermove", onPointer);
      window.removeEventListener("touchmove", onTouch);
      window.removeEventListener("touchstart", onTouch);
    };
  }, []);

  return null;
}
